import { render, staticRenderFns } from "./ScheduleDetails.vue?vue&type=template&id=2f0bf1ee&"
import script from "./ScheduleDetails.vue?vue&type=script&lang=js&"
export * from "./ScheduleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports